var exports = {
  "i": "wrapper__l14OG-",
};

module.exports = exports;
